module.exports = "/src/views/eternal-dev/businesses/gas-station/images/scale-mask.svg";